export default __webpack_public_path__ + "static/media/lang.3cd2d213.wav";